import React from "react";

import styles from "../../../../styles/integrations.module.scss";

import { EnvironmentStorage } from "../../../tools/EnvironmentStorage";
import { Loading } from "../../../components/Loading";
import { Drawer } from "../../../components/Drawer";
import { Input } from "../../../components/Input";
import { Button } from "../../../components/Button";
import { Context } from "pages/Integrations";
import { EnvironmentsAPI } from "providers/EnvironmentsAPI";
import { Select } from "@components";
import { Toggle } from "shared/components/Toggle";
import { IntegrationsAPI } from "providers/IntegrationsAPI";

export default class BlingStoreDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      loading: false,
      active: false,

      prefix: null,
      orderPrefix: null,
      methods: {},
      statuses: {},
    };
  }

  componentDidMount() {
    this.loadConfigs();
  }

  async loadConfigs() {
    const environmentId = EnvironmentStorage.getEnvironment().id;

    const configurationsResponse = await IntegrationsAPI.getBlingConfigurations(
      environmentId
    );
    const currentConfigurations = configurationsResponse.getData({});

    const externalCredentials = await EnvironmentsAPI.getConfigurationsByAlias(
      environmentId,
      "external_credentials",
      {}
    );

    this.setState({
      active: !!externalCredentials?.bling?.active,
      storeId: currentConfigurations?.storeId,
      prefix: currentConfigurations?.prefix,
    });

    this.setState({
      loadingPage: false,
    });
  }

  async onSave() {
    try {
      const { onSave } = this.props;
      const { active, storeId, prefix } = this.state;

      this.setState({ loading: true });

      const environmentId = EnvironmentStorage.getEnvironment().id;

      const configurationsResponse =
        await IntegrationsAPI.getBlingConfigurations(environmentId);
      const currentConfigurations = configurationsResponse.getData({});

      const newConfigurations = {
        ...currentConfigurations,
        storeId,
        prefix,
      };

      const updateResponse = await IntegrationsAPI.upsertBlingConfigurations(
        environmentId,
        newConfigurations
      );

      const externalCredentials =
        await EnvironmentsAPI.getConfigurationsByAlias(
          environmentId,
          "external_credentials",
          {}
        );
      const statusResponse = await EnvironmentsAPI.putConfigurationsByAlias(
        environmentId,
        "external_credentials",
        {
          ...externalCredentials,
          bling: {
            active,
          },
        }
      );

      this.setState({ loading: false });

      if (updateResponse.getErrors([]).length === 0) {
        onSave && onSave();
      } else {
        alert({
          text: `Não foi possível alterar a configuração: ${
            updateResponse.getErrors()[0]
          }`,
        });
      }
    } catch (e) {
      this.setState({ loading: false });
    }
  }

  render() {
    const { loading, loadingPage, active, storeId, prefix } = this.state;
    const { visible, onClose } = this.props;

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        closeInFade
        title={"Bling - Configurações"}
        footer={
          <Button
            design="primary"
            className="w-100"
            onClick={() => this.onSave()}
            loading={loading}
            disabled={loading}
          >
            Salvar alterações
          </Button>
        }
      >
        <Context />

        {loadingPage ? (
          <div className="d-flex justify-center align-center h-100">
            <Loading fullScreen />
          </div>
        ) : (
          <div className={styles.scrollContainer}>
            <div className={styles.toggle}>
              <div className="d-flex justify-end w-100">
                <Toggle
                  active={active}
                  onChange={(active) => this.setState({ active })}
                />
              </div>
            </div>

            <Input
              design="two"
              className="mb-20"
              floatLabel="Prefixo da loja"
              value={prefix}
              onChange={(e) => this.setState({ prefix: e.target.value })}
            />

            <Input
              design="two"
              className="mb-20"
              floatLabel="Código da loja"
              value={storeId}
              onChange={(e) => this.setState({ storeId: e.target.value })}
            />
          </div>
        )}
      </Drawer>
    );
  }
}
